import React from "react";
import PropTypes from 'prop-types';
import './Cell.css';

const Cell = ({ played }) => {
    return (
        <div 
            className={`Cell ${played}`} 
            data-testid='cell'
            role="gridcell"
            aria-label={played === 0 ? 'Empty cell' : `${played === 'r' ? 'Red' : 'Blue'} player cell`}
        />
    );
};

Cell.propTypes = {
    played: PropTypes.oneOf([0, 'r', 'b']).isRequired,
};

export default Cell;